import { metaTagString } from '../../utilities/meta_tags_util';

export default (urlPath, language, query, params) => {
  let metaData = '';

  metaData += metaTagString({
    urlPath,
    title: '',
    images: [],
    description: '',
    language,
    noindex: false,
  });

  return {
    metaData,
  };
};
